import { render, staticRenderFns } from "./PageMigration.vue?vue&type=template&id=f391e834&"
import script from "./PageMigration.vue?vue&type=script&lang=js&"
export * from "./PageMigration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f391e834')) {
      api.createRecord('f391e834', component.options)
    } else {
      api.reload('f391e834', component.options)
    }
    module.hot.accept("./PageMigration.vue?vue&type=template&id=f391e834&", function () {
      api.rerender('f391e834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/PageMigration.vue"
export default component.exports